import type { BitmapData } from "../../runtime";
import {
  EFF_enemyESlash,
  EFF_enemySwipe,
  EFF_enemySwordCharge,
  EFF_enemySwordChargeBig,
  EFF_explode,
  EFF_explodeB,
  EFF_explodeC,
  EFF_shotAbsorb,
  EFF_smoke,
  EFF_spark,
  EFF_warpInA,
  EFF_warpInB,
  SPR_enemyLaser,
  SPR_enemyShot,
  SPR_explodeHuge,
  SPR_missile,
  SPR_sickleShot,
} from "../assets";
import { EntityId } from "../ids";

/** An `assets.ts` sprite-sheet class; every one takes no meaningful arguments. */
export type SheetClass = new () => BitmapData;

/**
 * Compiled sheets for effects and projectiles that do not have authored entity
 * definitions. Enemy and boss sheets live only in the semantic sprite registry.
 */
export const STATIC_ENTITY_SHEETS: Readonly<
  Partial<Record<EntityId, SheetClass | null>>
> = {
  [EntityId.Spark]: EFF_spark,
  [EntityId.Explosion]: EFF_explode,
  [EntityId.MovingExplosion]: EFF_explodeB,
  [EntityId.OrbShot]: SPR_enemyShot,
  [EntityId.ShotAbsorb]: EFF_shotAbsorb,
  [EntityId.SmallWarp]: EFF_warpInA,
  [EntityId.EnemySwipeA]: EFF_enemySwipe,
  [EntityId.EnemySwipeB]: EFF_enemySwipe,
  [EntityId.Reserved18]: null,
  [EntityId.Reserved19]: null,
  [EntityId.Reserved20]: null,
  [EntityId.Reserved21]: null,
  [EntityId.Reserved22]: null,
  [EntityId.SwordCharge]: EFF_enemySwordCharge,
  [EntityId.EnemyESlashA]: EFF_enemyESlash,
  [EntityId.EnemyESlashB]: EFF_enemyESlash,
  [EntityId.LargeSwordCharge]: EFF_enemySwordChargeBig,
  [EntityId.RotatingLaser]: SPR_enemyLaser,
  [EntityId.LargeWarp]: EFF_warpInB,
  [EntityId.LargeExplosion]: EFF_explodeC,
  [EntityId.Smoke]: EFF_smoke,
  [EntityId.SickleShot]: SPR_sickleShot,
  [EntityId.HugeExplosion]: SPR_explodeHuge,
  [EntityId.Missile]: SPR_missile,
  [EntityId.LaserShot]: SPR_enemyLaser,
};
